export default "__VITE_ASSET__BkOK6FmA__"